import angular from 'angular';

import template from './tsz-scroll-top.html';
import './tsz-scroll-top.styl';

function controller($window) {

  'ngInject';

  this.atTop = () => $window.pageYOffset < 50;

  this.atTop1 = () => {
    const t = $window.pageYOffset < 50;
    console.log(`At top: ${t}.  offset: ${$window.pageYOffset}`);
    return t;
  };

}

function link($window, element) {
  angular.element($window).bind('scroll', () => {

    console.log(`pageyOffset: ${element.pageYOffset}`);

    if (element.pageYOffset > 0) {
      this.scrollClass = true;
      this.atTop = false;
    }
    this.$apply();
  });
}

export default {
  template,
  link,
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-scroll-top/tsz-scroll-top.js